const siteConfig = {
  siteUrl: 'https://www.kfz-gutachten-eg.de',
  companyName: 'KFZ-Gutachten-EG',
  contact: {
    street: 'Birnenpfad 3',
    postalCode: '53859',
    city: 'Niederkassel',
    phoneDisplay: '+49 2208 9377055',
    phoneLink: '+4922089377055',
    whatsappDisplay: '+49 2208 9377055',
    whatsappLink: '4922089377055',
    email: 'info@kfz-gutachten-eg.de'
  },
  operator: {
    name: 'Enes Gürbüz'
  },
  hero: {
    backgroundImageUrl: 'https://images.unsplash.com/photo-1493238792000-8113da705763?auto=format&fit=crop&w=1920&q=80'
  },
  about: {
    imageUrl: 'https://images.unsplash.com/photo-1485291571150-772bcfc10da5?auto=format&fit=crop&w=1400&q=80',
    imageAlt: 'KFZ-Sachverständiger bei der Fahrzeugbegutachtung'
  },
  socialLinks: {
    instagram: 'https://www.instagram.com/kfz_gutachten_kolnbonn?igsh=MTFib3pjOHVjaTlvag%3D%3D'
  },
  web3forms: {
    accessKey: '251e99ab-5d83-46e6-ad23-b7a4672a345f'
  },
  analytics: {
    googleAdsId: 'AW-18330497149',
    contactConversionLabel: 'YgiACLqBjewcEP3g1KRE'
  },
  legal: {
    impressumUrl: `${process.env.PUBLIC_URL}/impressum.html`,
    datenschutzUrl: `${process.env.PUBLIC_URL}/datenschutz.html`
  }
};

export default siteConfig;